module.exports = __webpack_public_path__ + "img/bsignup-continue-3@2x.6d7e227b.png";